import type { Api, Vendor } from '@cruz-com/lookup'
import { encodeQuery } from '@/lib'
import { baseURL, formatFetchError, getHeader } from '../util'

export async function location(params: object): Promise<Api.Result<Vendor.Location>> {
  try {
    const headers = await getHeader()
    const res = await fetch(`${baseURL}/carsforsale-import/location?${encodeQuery(params)}`, {
      method: 'GET',
      headers,
      next: { revalidate: 5 },
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}
